export default __webpack_public_path__ + "static/cover_1440-cdf6d20585be0a7b5522c14fadb59940.jpg";